import React from 'react';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import StatusBanner from '../common/StatusBanner';

class InvalidProxyAccess extends React.Component {

    constructor(props) {
        super(props);
        const { location } = this.props;        
        this.heading = location && location.state ? location.state.heading : "";
        this.subHeading = location && location.state ? location.state.subHeading : "";
    }
    
    componentDidMount() {        
        logUI(`MBHWeb.UI.InvalidProxyAccess.Grant.ComponentDidMount`, new Date(), Tools.getURLPath());
    }  

    render() {
                
        return (<div className="container-fluid body-content invalid-grant-container">
            <div className="row">
                <React.Fragment>
                    <div className="col-12">
                        <StatusBanner bannerMsg={this.heading} failedStatus>
                            <span>{this.subHeading}</span>
                        </StatusBanner>
                    </div>
                </React.Fragment>
            </div>
        </div>);
    }

}

export default InvalidProxyAccess;